import { Calculation } from 'final-form-calculate'
import { TipoAtendimentoEnum } from 'graphql/types.generated'
import { isEmpty } from 'lodash'
import { ProcedimentosAutomaticosAtendimentoIndividual } from 'types/enums'
import { v4 as uuidv4 } from 'uuid'
import {
  ProcedimentoAutomatico,
  ProcedimentosAutomaticos,
} from 'view/atendimentos/atendimento-individual/AtendimentoIndividualView'
import { meta, SoapState } from 'view/atendimentos/atendimento-individual/model'
import { ProcedimentoSigtapFieldModel } from 'view/atendimentos/detail/soap/desfecho/components/ProcedimentoSigtapField'

const createTipoAtendimentoCalculations = (
  isMedico: boolean,
  procedimentosAutomaticos: ProcedimentosAutomaticos
): Calculation => ({
  field: [meta.desfecho.tipoAtendimento.absolutePath()],
  updates: {
    [meta.desfecho.procedimentosAdministrativos.absolutePath()]: (
      tipoAtendimento: TipoAtendimentoEnum,
      allValues: SoapState,
      prevValues: SoapState
    ) => {
      if (!isEmpty(prevValues)) {
        return calculateProcedimentosAutomaticosByTipoAtendimento(allValues, isMedico, procedimentosAutomaticos)
      }
      return allValues.desfecho.procedimentosAdministrativos
    },
  },
})

export const calculateProcedimentosAutomaticosByTipoAtendimento = (
  allValues: SoapState,
  isMedico: boolean,
  procedimentosAutomaticos: ProcedimentosAutomaticos
): ProcedimentoSigtapFieldModel[] => {
  const isAtendimentoUrgencia = allValues.desfecho.tipoAtendimento === TipoAtendimentoEnum.URGENCIA
  const procedToAdd = isAtendimentoUrgencia
    ? ProcedimentosAutomaticosAtendimentoIndividual.ATENDIMENTO_DE_URGENCIA_NA_ATENCAO_BASICA
    : isMedico
    ? ProcedimentosAutomaticosAtendimentoIndividual.CONSULTA_MEDICA_EM_ATENCAO_BASICA
    : ProcedimentosAutomaticosAtendimentoIndividual.CONSULTA_DE_PROFISSIONAIS_DE_NIVEL_SUPERIOR_NA_ATENCAO_BASICA

  const procedRef = procedimentosAutomaticos.find((p) => p.codigo === procedToAdd)

  return getProcedimentosWithNewProced(allValues.desfecho.procedimentosAdministrativos, procedRef)
}

export const getProcedimentosWithNewProced = (
  proceds: ProcedimentoSigtapFieldModel[],
  newProced: ProcedimentoAutomatico
) => {
  let listProcedAdministrativos = proceds || []

  if (!newProced) {
    return listProcedAdministrativos.filter((proced) => !proced.automatico)
  }
  const containsProced = listProcedAdministrativos.find((proced) => proced.procedimento.codigo === newProced.codigo)
  if (!containsProced) {
    return listProcedAdministrativos
      .filter((proced) => !proced.automatico)
      .concat({
        _id: uuidv4(),
        procedimento: newProced,
        automatico: true,
      })
  }

  return listProcedAdministrativos
}

export const createDesfechoIndividualCalculations = (
  procedimentosAutomaticos: ProcedimentosAutomaticos,
  isMedico: boolean
): Calculation[] => [createTipoAtendimentoCalculations(isMedico, procedimentosAutomaticos)]
